/* Static Error Messages for UI (mostly provided by POs) */

export const errorMessages = {
    DEFAULT: `We cannot process your request at this time.
    Please try again later. If you are still receiving this message, please contact info@akc.org or
    AKC Customer Service at 919-816-3918.`,
    PREFLIGHT_FAILURE_MSG: `It is possible that there is a transaction for this dog already in 
    process. Please check the information you entered and try again. If the information you entered is 
    correct and you feel you are receiving this message in error, contact info@akc.org or AKC Customer 
    Service at 919-816-3918.`,
    PREFLIGHT_FAILURE_TITLE: 'Transaction already in progress'
}